import * as React from "react";
import { forwardRef, memo } from "react";
const SvgHu = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 3", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#477050", d: "M0 0h6v3H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#FFF", d: "M0 0h6v2H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#CE2939", d: "M0 0h6v1H0z" }));
const ForwardRef = forwardRef(SvgHu);
const Memo = memo(ForwardRef);
export default Memo;
